import React from "react";
import { FontAwesome } from "../../FontAwesome";
import { IFlexProps } from "../../Flex";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  containerProps?: IFlexProps;
}

// == Constants ============================================================

const DEFAULT_PROPS = {};

// == Component ============================================================

const ChevronCircleLeft = ({ containerProps, ...rest }: IProps) => {
  return (
    <FontAwesome
      containerProps={containerProps}
      data-testid="chevron-circle-left"
      icon="chevron-circle-left"
      {...rest}
    />
  );
};

ChevronCircleLeft.defaultProps = DEFAULT_PROPS;

export default ChevronCircleLeft;
// == Styles ===============================================================
